.dropdownTriangle {
  margin-left: var(--gap-regular);
  width: 0;
  height: 0;
  border-left: 0.6rem solid transparent;
  border-right: 0.6rem solid transparent;
  border-top: 0.6rem solid var(--color-white);
  transition: transform 180ms ease-in-out;

  &.dropdownTriangleOpened {
    transform: rotate(180deg);
  }
}

.content {
  padding: 0;
}
